import type { HTMLAttributes } from 'react';

type DsAlertSeverity = 'info' | 'warn' | 'error' | 'success';

interface DsAlertProps extends HTMLAttributes<HTMLDivElement> {
  severity: DsAlertSeverity;
}

export function DsAlert({ severity, className = '', children, ...props }: DsAlertProps) {
  const classes = ['ds-alert', severity, className].filter(Boolean).join(' ');
  return (
    <div className={classes} role="alert" {...props}>
      {children}
    </div>
  );
}
